import React from 'react'
import {useRouter} from 'next/router'

import {createLog} from '@util/logs'
import {setUserProperty} from '@util/amplitude'
import {DarkModeStore} from '@store/DarkmodeStore'
import useDark from '@hook/useDark'
import {useTranslation} from '@lib/intl/useTranslations'

import Text from '@component/Text/Text'
import WizTextSwitch from '@component/switchs/WizTextSwitch'

interface IProps {
    className?: string
}

const AppearanceSettingOperation = ({className}: IProps) => {
    const t = useTranslation()
    const router = useRouter()

    const {toggleDarkMode} = DarkModeStore()
    const {isRenderDark} = useDark()

    const onChangeDarkState = () => {
        return isRenderDark ? 'dark' : 'light'
    }

    const onClickToggleDarkMode = () => {
        const mode = onChangeDarkState()
        createLog('event', 'navigation_toggle_dark_mode', {mode})
        setUserProperty('dark_mode', mode)
        toggleDarkMode()
    }

    const lightTitle = t('globalNavigation.appearance.light')
    const darkTitle = t('globalNavigation.appearance.dark')
    return (
        <div className={`flex items-center justify-between px-[15px] py-[10px] ${className}`}>
            <Text className={' text-btn_sm text-gray01 dark:text-dark_gray01'}>
                {t('globalNavigation.appearance.title')}
            </Text>
            <WizTextSwitch
                values={[lightTitle, darkTitle]}
                checked={isRenderDark}
                onChangeValue={onClickToggleDarkMode}
                toggleClassName={
                    router?.locale === 'ko'
                        ? `after:content-['라이트'] peer-checked:after:content-['다크'] peer-checked:after:ml-[14px]`
                        : `after:content-['Light'] peer-checked:after:content-['Dark'] peer-checked:after:ml-[4px]`
                }
            />
        </div>
    )
}
export default AppearanceSettingOperation
